export default "__VITE_ASSET__7a46f34f__"